import React from 'react';
import MarketingNav from '../components/layout/MarketingNav';
import MarketingFooter from '../components/layout/MarketingFooter';
import Section from '../components/common/Section';
import SectionHeader from '../components/common/SectionHeader';
import Badge from '../components/ui/Badge';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen">
      <MarketingNav transparent={false} />

      <main>
        <Section background="light" padding="xl">
          <div className="max-w-3xl">
            <Badge variant="primary" className="mb-4">Terms of Service</Badge>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6">Terms for using MHDF Momentum</h1>
            <p className="text-lg md:text-xl text-text-muted">
              These terms govern your use of the MHDF Momentum platform.
            </p>
            <p className="mt-4 text-sm text-neutral-500">Last updated: February 4, 2026</p>
          </div>
        </Section>

        <Section background="white" padding="lg">
          <SectionHeader
            badge="Agreement"
            title="Key terms"
            subtitle="By using this platform, you agree to these terms."
            alignment="left"
          />

          <div className="mt-8 space-y-6 text-sm text-neutral-700">
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Eligibility</h3>
              <p className="mt-2 text-neutral-600">You must be at least 18 years old to use this service.</p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Use of the service</h3>
              <p className="mt-2 text-neutral-600">
                Use MHDF Momentum for personal mental wellness companionship support. Do not misuse the service or attempt unauthorized access.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Clinical disclaimer</h3>
              <p className="mt-2 text-neutral-600">
                MHDF Momentum is a supplement to professional care. It is not emergency or crisis treatment.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Account responsibilities</h3>
              <p className="mt-2 text-neutral-600">
                You are responsible for maintaining the confidentiality of your account credentials.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Termination</h3>
              <p className="mt-2 text-neutral-600">
                We may suspend or terminate accounts that violate these terms or pose security risks.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Contact</h3>
              <p className="mt-2 text-neutral-600">Email support@mhdfmomentum.com for questions.</p>
            </div>
          </div>
        </Section>
      </main>

      <MarketingFooter />
    </div>
  );
};

export default TermsOfServicePage;
